module.exports = __webpack_public_path__ + "img/ic-materiaux.f8aebbd1.svg";